import {
  resourceReducer,
} from 'redux-resource';
import {
  includedResources,
} from 'redux-resource-plugins';
import {
  allListPlugin,
  customListPlugin,
  multiListPlugin,
} from './plugins';

export default resourceReducer('workoutEvents', {
  plugins: [
    includedResources,
    allListPlugin,
    customListPlugin,
    multiListPlugin,
  ],
});
